import Content from "../../help/master-schedules.mdx";

export function MasterSchedulesHelpPage() {
  return <Content />;
}
